import StylesApp from '@/StylesApp'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

const domContainer = document.querySelector('#theme')
if (domContainer) {
  const appEl = createRoot(domContainer)
  appEl.render(createElement(StylesApp))
}
